export default function TemplateResumeBadge() {
  return (
    <span className="inline-flex items-center rounded-full bg-brand-primary/10 px-2 py-0.5 text-xs font-medium text-brand-primary shrink-0">
      Template
    </span>
  )
}
